(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carnez-shop-by-moment"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('.carnez-moment');
  sections.forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const tabs = root.querySelectorAll('.carnez-moment__tab');
    const title = root.querySelector('[data-moment-title]');
    const copy = root.querySelector('[data-moment-copy]');
    const cta = root.querySelector('[data-moment-cta]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected','false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected','true');
        title.textContent = tab.dataset.title || '';
        copy.textContent = tab.dataset.copy || '';
        cta.textContent = tab.dataset.cta || '';
        cta.setAttribute('href', tab.dataset.link || '#');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
